import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';

import { BaseModalComponent } from '../../modal/_base-modal.component';
import { ChangeStatusesTableRowModel } from './change-statuses-table-row.model';


@Component({
  moduleId: module.id,
  selector: 'change-statuses-modal',
  templateUrl: 'change-statuses-modal.component.html',
  styleUrls: ['change-statuses-modal.component.scss'],
})
export class ChangeStatusesModalComponent extends BaseModalComponent {
  @Input() title: string;
  @Input() columnNames: string[] = [];
  @Input() statuses: Array<ChangeStatusesTableRowModel> = [];

  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();

  onConfirmClick() {
    this.confirm.emit();
  }

  onCancelClick() {
    this.cancel.emit();
    this.hide();
  }

}
